import type { RelatedPlace } from "~/lib/api";
import { isMtbTrailRelatedPlace } from "~/lib/api";
import type { RelatedPlaceCategory } from "~/lib/relatedPlaces";
import { RelatedPlacesSection } from "~/components/landing/RelatedPlacesSection";

interface BikeParkNearbyPlacesProps {
  relatedPlaces: RelatedPlace[];
  onSelect: (place: RelatedPlace) => void;
}

const NEARBY_CATEGORIES: RelatedPlaceCategory[] = [
  { label: "Bike Shops", emptyLabel: "", icon: "bike-shop", types: ["bike-shop"] },
  { label: "Eats & Drinks", emptyLabel: "", icon: "restaurant", types: ["restaurant", "cafe", "bar"] },
  { label: "Places to Stay", emptyLabel: "", icon: "accommodation", types: ["accommodation"] },
  { label: "Other spots", emptyLabel: "", icon: "map-pin", types: null },
];

export function BikeParkNearbyPlaces({ relatedPlaces, onSelect }: BikeParkNearbyPlacesProps) {
  const nearby = relatedPlaces.filter((p) => !isMtbTrailRelatedPlace(p));

  if (nearby.length === 0) return null;

  return <RelatedPlacesSection relatedPlaces={nearby} onSelect={onSelect} categories={NEARBY_CATEGORIES} />;
}
